import { localStorage } from 'dibs-browser-storage';

export const PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP_DISMISSED_KEY =
    'PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP_DISMISSED';
export const PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP_SEEN_KEY =
    'PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP_SEEN';
export const PDP_TRADE_REQUEST_APPOINTMENT_COACHMARK_VIEW_COUNT_KEY =
    'PDP_TRADE_REQUEST_APPOINTMENT_COACHMARK';

export const getPdpCoachmarkViews: () => number = () =>
    localStorage.getItem(PDP_TRADE_REQUEST_APPOINTMENT_COACHMARK_VIEW_COUNT_KEY) || 0;

export const incrementCoachmarkViews: () => void = () =>
    localStorage.setItem(
        PDP_TRADE_REQUEST_APPOINTMENT_COACHMARK_VIEW_COUNT_KEY,
        getPdpCoachmarkViews() + 1
    );

export const hasUserSeenTooltip = localStorage.getItem(
    PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP_SEEN_KEY
);

export const setUserHasSeenTooltip: () => void = () =>
    localStorage.setItem(PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP_SEEN_KEY, true);

export const hasTooltipBeenDismissed = !!localStorage.getItem(
    PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP_DISMISSED_KEY
);

export const setTooltipHasBeenDismissed: () => void = () =>
    localStorage.setItem(PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP_DISMISSED_KEY, true);

const COACHMARK_VIEW_LIMIT = 10;
export const checkIfShouldShowCoachmark: () => boolean = () =>
    getPdpCoachmarkViews() < COACHMARK_VIEW_LIMIT && !hasTooltipBeenDismissed;
